// extracted by mini-css-extract-plugin
export default {"content":"style_content__vlCoF","checkbox":"style_checkbox__3kHo4"};